import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ALLOWED = ["/app/billing", "/app/account"];

/* Card-required billing: until a Stripe trial/subscription exists, every /app route sends you to pick a plan. */
export function BillingGate({ children }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user?.needs_checkout && !ALLOWED.some((p) => loc.pathname.startsWith(p))) {
    return <Navigate to="/app/billing?start=1" replace state={{ from: loc.pathname }} />;
  }
  return children;
}
